import { gql } from "@apollo/client";
import { AsyncActionStatus } from "../../models/AsyncActionStatus";
import { getErrors } from "../../utils";
import { useResettableMutation } from "../useResettableMutation";
import { AddPermitToDig, AddPermitToDigVariables } from "./__generated__/AddPermitToDig";

const ADD_PERMIT = gql`
  mutation AddPermitToDig(
    $permitDataInput: PermitDataInput
    $number: Int!
    $permitRegisterId: String!
    $sourceId: String
    $documentIds: [String!]
    $calibrationCertificate: CalibrationCertificateInput
    $asBuiltRequired: Boolean!
    $areas: [AreaInput!]
    $permitAssignmentInputs: [PermitAssignmentInput!]
    $sitePhotos: [SitePhotoInput]
    $permitTypeId: String
    $fieldValues: [PermitFieldValueInput]
  ) {
    addPermitToDig(
      input: {
        permitDataInput: $permitDataInput
        number: $number
        permitRegisterId: $permitRegisterId
        sourceId: $sourceId
        documentIds: $documentIds
        calibrationCertificate: $calibrationCertificate
        asBuiltRequired: $asBuiltRequired
        areas: $areas
        permitAssignmentInputs: $permitAssignmentInputs
        sitePhotos: $sitePhotos
        permitTypeId: $permitTypeId
        fieldValues: $fieldValues
      }
    ) {
      permitToDig {
        id
      }
    }
  }
`;

export function useAddPermit() {
  const [mutate, { loading, data, error, reset, called }] = useResettableMutation<
    AddPermitToDig,
    AddPermitToDigVariables
  >(ADD_PERMIT, {
    errorPolicy: "all",
  });
  return {
    mutate,
    data,
    status: {
      loading,
      reset,
      called,
      errors: getErrors(error),
      successful: !error && data ? true : false,
    } as AsyncActionStatus,
  };
}
